import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { useBreakpoint as p, Breakpoints as r, Carousel as d } from "@nextgen-web-framework/all";
import { s as t, M as u } from "../../MeetOurPeopleItem-a71678d9.mjs";
const h = (o) => {
  const l = p(), a = [r.SM, r.XS].includes(l);
  return /* @__PURE__ */ i("div", { className: t["meet-our-people-container"], "data-testid": "meet-our-people-test-id", "data-pod-name": "commerce", children: [
    /* @__PURE__ */ e("h3", { className: t["meet-our-people-title-section"], children: o.displayTitle }),
    /* @__PURE__ */ e("div", { className: t["meet-our-people-carousel-section"], children: /* @__PURE__ */ e("div", { className: t["meet-our-people-carousel"], children: /* @__PURE__ */ e(
      d,
      {
        id: "Meet-Our-People-Carousel",
        hideButtons: !0,
        isTileCarousel: !0,
        dotsPaddingTop: a ? 16 : 32,
        children: o.meetOurPeopleData.map((s) => /* @__PURE__ */ e(u, { ...s }, `${s.title}`))
      }
    ) }) })
  ] });
};
export {
  h as default
};
//# sourceMappingURL=MeetOurPeople.js.map
